import React, { useMemo } from 'react'
import { FeatureFlag } from '@openfeature/react-sdk'
import { CircleDollarSignIcon, InfoIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { VideoTutorials } from '@/entities/video-tutorial'

import {
	PricingCampaignsProvider,
	PricingCampaignsView,
} from '@/widgets/pricing-campaigns-table'

import { ErrorBoundaryWithUser } from '@/shared/components/ErrorBoundary'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbList,
	BreadcrumbPage,
} from '@/shared/components/ui/breadcrumb'
import { Button } from '@/shared/components/ui/button'
import { Header, Layout } from '@/shared/components/ui/layout'
import { Separator } from '@/shared/components/ui/separator'
import { VideoTag } from '@/shared/generated'

import { PricingCampaignExportSettings } from './PricingCampaignExportSettings'

export const PricingCampaignsPage = () => {
	const { t } = useTranslation()

	return (
		<ErrorBoundaryWithUser showDialog>
			<Layout>
				<Header className='h-11 items-center gap-2 border-b px-4 py-2'>
					<CircleDollarSignIcon className='size-4' />
					<Separator orientation='vertical' className='h-5' />
					<Breadcrumb className='mr-auto text-sm'>
						<BreadcrumbList>
							<BreadcrumbItem>
								<BreadcrumbPage>
									{t('menu.pricing_campaigns', {
										defaultValue: 'Pricing campaigns',
									})}
								</BreadcrumbPage>
							</BreadcrumbItem>
						</BreadcrumbList>
					</Breadcrumb>
					<FeatureFlag flagKey='po_enable_pc_export' defaultValue={false}>
						<PricingCampaignExportSettings />
					</FeatureFlag>
					<VideoTutorials tags={[VideoTag.PricingCampaignList]}>
						<Button size='icon' variant='ghost'>
							<InfoIcon />
						</Button>
					</VideoTutorials>
				</Header>
				<PricingCampaignsProvider scope={useMemo(() => ({}), [])}>
					<PricingCampaignsView />
				</PricingCampaignsProvider>
			</Layout>
		</ErrorBoundaryWithUser>
	)
}
